import React from 'react'
import PaletteWrapper from './palette-wrapper'
import { SmartContainer } from '@uswitch/ev-core/react'
import { ConditionalWrapper } from '@uswitch/ev-utils/lib/conditional-wrapper'
import HeaderFooterWrapper from './header-footer-wrapper'

const withComponentBase = (Component, options = {}) => props => {
  const {
    withPalette = false,
    withContainer = false,
    withHeaderFooter = false,
    defaultPalette,
    headerStyles,
    footerStyles,
    wrapperStyles,
  } = typeof options === 'function' ? options(props) : options

  return (
    <ConditionalWrapper
      {...props}
      palette={props.palette || defaultPalette}
      condition={withPalette}
      wrapper={PaletteWrapper}
      componentName={Component?.displayName || Component?.name}
    >
      <ConditionalWrapper
        {...{ useContainer: withContainer, ...props }}
        condition={withContainer}
        wrapper={SmartContainer}
      >
        <ConditionalWrapper
          {...{ headerStyles, footerStyles, wrapperStyles, ...props }}
          condition={withHeaderFooter}
          wrapper={HeaderFooterWrapper}
        >
          <Component {...props} />
        </ConditionalWrapper>
      </ConditionalWrapper>
    </ConditionalWrapper>
  )
}

export default withComponentBase
